export default __webpack_public_path__ + "static/media/timeline-icon.0ce485a4.svg";